module.exports = __webpack_public_path__ + "static/media/skila-bg_img-01-2-pod_600px_width-0_1-@1x.b97a5bd0.png";